import AbstractMapper from './AbstractMapper'

class ColumnMapper extends AbstractMapper {
  azienda (hasRoot) {
    const key = 'idazi'
    return super.column(key, hasRoot ? 'aziende/{' + key + '}' : '{' + key + '}', this.replace(key))
  }

  ambito () {
    const key = 'ambito'
    return super.column(key, 'ambito/{' + key + '}', this.replace(key))
  }
}

export default new ColumnMapper()
